import SEO from "../../../data/seo";
import HeaderOne from "../../../layout/headers/header-one";
import BannerOne from "./banner";
import About from "./about";
import TextSlide from "./text-slide";
import Services from "./services";
import Video from "./video";
import ChooseUs from "./choose-us";
import Portfolio from "./portfolio";
import CounterUp from "./counter";
import Experience from "./experience";
import Testimonial from "./testimonial";
import Blog from "./blog";
import HomeCta from "./cta"; // Import the new CTA
import FooterOne from "../../../layout/footers/footer-one";

const HomeOne = () => {
    return (
        <div>
            <SEO pageTitle='Arclight Developers | Construction & Civil Work' />
            <HeaderOne />
            <BannerOne />
            <About />
            <TextSlide />
            <Services />
            {/* <Video /> */}
            <ChooseUs />
            {/* <Portfolio /> */}
            {/* <CounterUp /> */}
            <Experience />
            {/* <Testimonial />  */}
            <Blog /> 
            {/* <HomeCta /> */}
            <FooterOne />
        </div>
    );
};

export default HomeOne;